import React from 'react';

import DroneMRM from '../../../main/assets/images/mrm1-5/robust-airframe.webp';

export const Dominate = () => {
  return (
    <section className="newhomepage-dominate-section">
      <img
        src={DroneMRM}
        alt="Full View of MRM1-5 Product Drone"
        className="newhomepage-dominate-product"
      />
      <div className="newhomepage-dominate-text">
        <div className="newhomepage-dominate-text-titles">
          <h2 className="newhomepage-dominate-text-subtitle">TECHNOLOGY</h2>
          <h3 className="newhomepage-dominate-text-title">BUILT TO DOMINATE</h3>
        </div>
        <p className="newhomepage-dominate-text-description">
          Unlike competitors who just assemble third-party parts, Orqa’s full
          vertical integration means we design and manufacture every component
          ourselves. This gives us the freedom to fine-tune functionality and
          optimize performance where it really counts.
        </p>
      </div>
    </section>
  );
};
